export const sessionIdParm = (session) => (
    (session.sessionId === '') ? '' : "&SESSIONID=" + session.sessionId
)

export default sessionIdParm